<template>
    <div class="inline-note-field" :class="{ focused, hovered, readonly }">
        <textarea
            ref="textarea"
            class="inline-note-textarea ppv2-text-black"
            :class="{ 'ppv2-bg-black ppv2-bg-opacity-5': hovered && !readonly, 'ppv2-bg-white dark:ppv2-bg-dark': focused }"
            :value="value"
            rows="1"
            spellcheck="false"
            :readonly="readonly"
            :placeholder="placeholder"
            @input="onInput"
            @focus="focused = true"
            @blur="focused = false"
            @mouseenter="hovered = true"
            @mouseleave="hovered = false"
        ></textarea>
        <span v-if="!readonly" class="inline-note-pencil">
            <Pencil :size="15" />
        </span>
    </div>
</template>

<script>
import { Pencil } from 'lucide-vue'

export default {
    name: 'InlineNoteField',
    components: { Pencil },
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        // Mode lecture seule : textarea non éditable (ex. devis accepté/verrouillé).
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            focused: false,
            hovered: false,
        }
    },
    mounted() {
        this.autoGrow(this.$refs.textarea)
    },
    methods: {
        onInput(e) {
            // En lecture seule, aucune modification n'est propagée.
            if (this.readonly) return
            this.autoGrow(e.target)
            this.$emit('input', e.target.value)
        },
        autoGrow(el) {
            if (!el) return
            el.style.height = 'auto'
            el.style.height = el.scrollHeight + 'px'
        },
    },
}
</script>

<style scoped lang="scss">
.inline-note-field {
    position: relative;

    .inline-note-textarea {
        width: calc(100% + 20px);
        margin: -8px -10px;
        padding: 8px 32px 8px 10px;
        border: 1px dashed transparent;
        border-radius: 8px;
        background: transparent;
        box-shadow: none;
        font-family: inherit;
        font-size: 13px;
        line-height: 1.7;
        resize: none;
        overflow: hidden;
        outline: none;
        transition:
            background 0.15s ease,
            border-color 0.15s ease,
            box-shadow 0.15s ease;

        &::placeholder {
            color: #9aa4b2;
        }

        cursor: text;
    }

    .inline-note-pencil {
        position: absolute;
        top: 6px;
        right: 8px;
        display: flex;
        pointer-events: none;
        color: #6b7480;
        opacity: 0;
        transform: translateX(3px);
        transition:
            opacity 0.15s ease,
            transform 0.15s ease,
            color 0.15s ease;
    }

    &.hovered {
        .inline-note-textarea {
            border-style: dashed;
            border-color: #cbd2dc;
        }

        .inline-note-pencil {
            opacity: 1;
            transform: translateX(0);
        }
    }

    &.focused {
        .inline-note-textarea {
            border-style: solid;
            border-color: #7d2dbd;
            box-shadow: 0 0 0 3px #f3eafa;
        }

        .inline-note-pencil {
            opacity: 1;
            transform: translateX(0);
            color: #7d2dbd;
        }
    }

    // Lecture seule : aucune affordance d'édition (ni bordure, ni ombre).
    &.readonly {
        .inline-note-textarea {
            cursor: not-allowed;
            border-color: transparent;
            box-shadow: none;
        }
    }
}
</style>
